module.exports = __webpack_public_path__ + "img/create_bot_img.5ec7ff22.png";